/**
 * Active announcement slug. null = feature disabled.
 * Must match a key under announcement_modal in locales.
 */
export const ACTIVE_ANNOUNCEMENT_MESSAGE_VERSION: string | null =
  'maintenance_may_2026';
